import React, { memo, useState } from 'react';
import { Row, Col, Modal } from 'react-bootstrap';
import DoneButton from '../atoms/DoneButton';
import {
  KWANKGM11010A01,
  KWANKGM11010A02,
  KWANKGM11010A03,
  KWANKGM11010A04,
} from '../const/api_modules';
import { fileDownload } from '../FileDownload';
import { content_type } from '../Const';
import { RequestDetail } from '../types/CoomonApiDetail';

interface Props {
  reception_id: number;
  reception_cd: string;
  is_sent_to_guaranty_company: boolean;
  is_csv_downloaded: boolean;
  management_store_cd: string;
  has_hosho_flg: boolean; // 保証機関連携対象フラグ
  requestCommonApi: (
    module_name: string,
    is_json: boolean,
    is_blob: boolean,
    details: RequestDetail[]
  ) => Promise<any>;
}

// KWANKGM11010_事前審査案件詳細（職員）
const FooterPreExaminationProjectDetails: React.FC<Props> = ({
  reception_id,
  reception_cd,
  is_sent_to_guaranty_company,
  is_csv_downloaded,
  management_store_cd,
  has_hosho_flg,
  requestCommonApi,
}) => {
  const [modal_decline_confirm, setModalDeclineConfirm] = useState(false);
  const [modal_decline_notification, setModalDeclineNotification] = useState(false);
  const [modal_csv_download, setModalCsvDownload] = useState(false);
  const [modal_alignment_confirm, setModalAlignmentConfirm] = useState(false);
  const [modal_management_store, setModalManagementStore] = useState(false);
  const [modal_error_message, setModalErrorMessage] = useState(false);
  const [error_message, setErrorMessage] = useState('');
  const [error_redirect_url, setErrorRedirectUrl] = useState('');

  const [is_download_done, setIsDownloadDone] = useState(false); // ダウンロード済か否か
  const [is_alignment_done, setIsAlignmentDone] = useState(false); // 保証機関連携済か否か

  // 「戻る」ボタンクリック時のアクション
  const handleClickReturn = () => {
    location.href = `${location.origin}${process.env.MIX_MOCK_URL}/staff/list`;
  };

  /**
   * 取下げ確認ポップアップの「お客様辞退」ボタンクリック時のアクション
   * @returns void
   */
  const handleClickCustomerDecline = () => {
    setErrorMessage('');
    requestCommonApi(KWANKGM11010A03, true, false, [])
      .then(() => {
        setModalDeclineConfirm(false);
        setModalDeclineNotification(true);
      })
      .catch(error => {
        setErrorMessage(error.response.data.message);
        setErrorRedirectUrl(error.response.data.url);
        setModalErrorMessage(true);
        setModalDeclineConfirm(false);
      });
  };
  /**
   * 「お客様辞退」が正常終了した後の結果通知ダイアログのOKボタンを押下
   * @returns void
   */
  const handleClickCustomerDeclineComplete = () => {
    setModalDeclineNotification(false);
    location.replace(`${location.origin}${process.env.MIX_MOCK_URL}/staff/list`);
  };

  /**
   * ダウンロード確認ポップアップの「OK」ボタンをクリックする
   * @returns void
   */
  const handleClickDownloadConfirm = () => {
    setModalCsvDownload(false);
    requestCommonApi(KWANKGM11010A01, false, true, [])
      .then(res => {
        // ファイルのダウンロードを実行する
        fileDownload(res.data, res.headers['content-disposition'], content_type.csv);
        setIsDownloadDone(true);

        // console.log('DOWNLOAD_TOKEN', getCookie());
      })
      .catch(error => {
        setErrorMessage('システムエラーが発生しました');
        setModalErrorMessage(true);
      });
  };

  /**
   * 保証機関連携確認ポップアップの「OK」ボタンをクリックする
   * @returns void
   */
  const handleClickAlignmentConfirm = () => {
    setModalAlignmentConfirm(false);
    requestCommonApi(KWANKGM11010A02, true, false, [])
      .then(res => {
        // ファイルのダウンロードを実行する
        setIsAlignmentDone(true);
      })
      .catch(error => {
        setErrorMessage(error.response.data.message);
        setErrorRedirectUrl(error.response.data.url);
        setModalErrorMessage(true);
      });
  };

  /**
   * 管理店を登録する確認ポップアップの「登録」ボタンをクリックする
   * @returns void
   */
  const handleClickManagementStore = () => {
    setModalManagementStore(false);
    const detail = [
      {
        id: 1,
        name: 'mng_bank_branch_cd',
        value: management_store_cd,
      },
    ];

    if (!management_store_cd) {
      alert('管理店を選択して下さい');
      return;
    }

    requestCommonApi(KWANKGM11010A04, true, false, detail)
      .then(res => {
        location.replace(`${location.origin}${process.env.MIX_MOCK_URL}/staff/list`);
      })
      .catch(error => {
        setErrorMessage(error.response.data.message);
        setErrorRedirectUrl(error.response.data.url);
        setModalErrorMessage(true);
      });
  };

  /**
   * 次へボタンをクリックする
   * @returns void
   */
  const handleClickNext = () => {
    location.replace(
      `${location.origin}${process.env.MIX_MOCK_URL}/reception/${reception_cd}/${reception_id}/result_input`
    );
  };

  // エラーポップアップのOKボタン押下時
  const handleClickErrorConfirm = () => {
    location.replace(error_redirect_url);
  };

  return (
    <>
      <Row className="my-5 footer-controller">
        <Col xl={2} lg={2} md={2} sm={2} xs={12} className="text-center">
          <a
            className="btn btn-bg-white btn-outline-success btn-text-color btn-system"
            onClick={handleClickReturn}
          >
            戻る
          </a>
        </Col>
        <Col xl={2} lg={2} md={2} sm={2} xs={12} className="text-center">
          <a className="btn btn-important btn-system" onClick={() => setModalDeclineConfirm(true)}>
            お客様辞退
          </a>
        </Col>
        <Col xl={2} lg={2} md={2} sm={2} xs={12} className="text-center">
          <DoneButton
            label="ダウンロード"
            handleClick={() => setModalCsvDownload(true)}
            is_done={is_csv_downloaded || is_download_done}
          />
        </Col>
        {has_hosho_flg && (
          <Col xl={2} lg={2} md={2} sm={2} xs={12} className="text-center">
            <DoneButton
              label="保証機関連携"
              handleClick={() => setModalAlignmentConfirm(true)}
              is_done={is_sent_to_guaranty_company || is_alignment_done}
            />
          </Col>
        )}
        <Col xl={2} lg={2} md={2} sm={2} xs={12} className="text-center">
          <a className="btn btn-success btn-system" onClick={() => setModalManagementStore(true)}>
            管理店を登録
          </a>
        </Col>
        <Col xl={2} lg={2} md={2} sm={2} xs={12} className="text-center">
          <a className="btn btn-success btn-system" onClick={handleClickNext}>
            次へ
          </a>
        </Col>
      </Row>
      {/* 取下げ確認ポップアップ */}
      <Modal
        show={modal_decline_confirm}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => {}}
      >
        <Modal.Body>申込はお客様辞退となります。よろしいですか？</Modal.Body>
        <Modal.Footer>
          <a
            className="btn btn-bg-white btn-outline-success btn-text-color"
            onClick={() => setModalDeclineConfirm(false)}
          >
            戻る
          </a>
          <a className="btn btn-important" onClick={handleClickCustomerDecline}>
            お客様辞退
          </a>
        </Modal.Footer>
      </Modal>
      {/* 取下げ通知ポップアップ */}
      <Modal
        show={modal_decline_notification}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => {}}
      >
        <Modal.Body>申込はお客様辞退となりました。</Modal.Body>
        <Modal.Footer>
          <a className="btn btn-success" onClick={handleClickCustomerDeclineComplete}>
            OK
          </a>
        </Modal.Footer>
      </Modal>
      {/* CSVダウンロード確認ポップアップ */}
      <Modal
        show={modal_csv_download}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => {}}
      >
        <Modal.Body>CSVデータのダウンロードを開始します。よろしいですか？</Modal.Body>
        <Modal.Footer>
          <a
            className="btn btn-bg-white btn-outline-success btn-textcolor"
            onClick={() => setModalCsvDownload(false)}
          >
            キャンセル
          </a>
          <a className="btn btn-success" onClick={handleClickDownloadConfirm}>
            OK
          </a>
        </Modal.Footer>
      </Modal>
      {/* 三菱UFJニコスへの送信確認ポップアップ */}
      <Modal
        show={modal_alignment_confirm}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => {}}
      >
        <Modal.Body>三菱UFJニコスへ申込情報を連携します。よろしいですか？</Modal.Body>
        <Modal.Footer>
          <a
            className="btn btn-bg-white btn-outline-success btn-text-color"
            onClick={() => setModalAlignmentConfirm(false)}
          >
            戻る
          </a>
          <a className="btn btn-success" onClick={handleClickAlignmentConfirm}>
            送信
          </a>
        </Modal.Footer>
      </Modal>
      {/* 管理店登録確認ポップアップ */}
      <Modal
        show={modal_management_store}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => {}}
      >
        <Modal.Body>入力された管理店を登録します。よろしいですか？</Modal.Body>
        <Modal.Footer>
          <a
            className="btn btn-bg-white btn-outline-success btn-text-color"
            onClick={() => setModalManagementStore(false)}
          >
            戻る
          </a>
          <a className="btn btn-success" onClick={handleClickManagementStore}>
            登録
          </a>
        </Modal.Footer>
      </Modal>
      {/* エラー表示 */}
      <Modal
        show={modal_error_message}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => {}}
      >
        <Modal.Body>{error_message}</Modal.Body>
        <Modal.Footer>
          <a className="btn btn-success" onClick={handleClickErrorConfirm}>
            OK
          </a>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default memo(FooterPreExaminationProjectDetails);
